import { render, staticRenderFns } from "./ReporteAsignaturaSalle.vue?vue&type=template&id=5bbb479f&scoped=true"
import script from "./ReporteAsignaturaSalle.vue?vue&type=script&lang=js"
export * from "./ReporteAsignaturaSalle.vue?vue&type=script&lang=js"
import style0 from "./ReporteAsignaturaSalle.vue?vue&type=style&index=0&id=5bbb479f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb479f",
  null
  
)

export default component.exports